import { IRoute } from '../../utils/navigation/routes';
import ConfigureLinePage from '.';
import BlockedNumberSpecials from './BlockedNumberSpecials';
import CallDivert from './CallDivert';
import ConfigureLineFeedback from './ConfigureLineFeedback';
import Roaming from './Roaming';
import InstallWithQr from './InstallSims/installWithQr';
import FeedBackDuplicateSim from './DuplicateSims/feedBackDuplicateSim';
import FeedBackQREsim from './DuplicateSims/feedbackQREsim';
import BlockedLine from './BlockedLine';
import BlockedLineFeedback from './BlockedLine/BlockedLineFeedback';
import DuplicateSim from './DuplicateSims';
import DuplicateSimRequest from './DuplicateSims/DuplicateSimRequest';
import ActivateSim from './InstallSims/ActivateSim';
import FeedbackSimActivation from './InstallSims/FeedbackSimActivation';
import MultiSims from './MultiSims';
import FeedBackMultiSimHire from './MultiSims/FeedbackMultiSimHire';

export const configureLineRoutes: IRoute[] = [
    { path: '/configure-line', element: <ConfigureLinePage /> },
    { path: '/configure-line/roaming', element: <Roaming /> },
    { path: '/configure-line/roaming/feedback/:context', element: <ConfigureLineFeedback /> },
    { path: '/configure-line/blocked-number-specials', element: <BlockedNumberSpecials /> },
    { path: '/configure-line/blocked-number-specials/feedback/:context', element: <ConfigureLineFeedback /> },
    { path: '/configure-line/block-line', element: <BlockedLine /> },
    { path: '/configure-line/block-line/feedback', element: <BlockedLineFeedback /> },
    { path: '/configure-line/calldivert', element: <CallDivert /> },
    { path: '/configure-line/sim/installWithQr', element: <InstallWithQr /> },
    { path: '/configure-line/sim/feedbackDuplicateSIM', element: <FeedBackDuplicateSim /> },
    { path: '/configure-line/sim/feedbackSeeQRESIM', element: <FeedBackQREsim /> },
    { path: '/configure-line/sim/duplicate', element: <DuplicateSim /> },
    { path: '/configure-line/sim/duplicate/request', element: <DuplicateSimRequest /> },
    { path: '/configure-line/sim/activate-sim', element: <ActivateSim /> },
    { path: '/configure-line/sim/sim-activation-feedback', element: <FeedbackSimActivation /> },
    { path: '/configure-line/multiSim', element: <MultiSims /> },
    { path: '/configure-line/multiSim/duplicate', element: <DuplicateSim /> },
    { path: '/configure-line/multiSim/duplicate/request', element: <DuplicateSimRequest /> },
    { path: '/configure-line/multiSim/feedbackMultiSim', element: <FeedBackMultiSimHire /> },
];
